import { ReportsFilters, ReportsSortOrder } from '@models/interfaces';

export const DEFAULT_REPORT_FILTERS: ReportsFilters = {
  page: 1,
  size: 25,
};

export const REPORT_TAB_QUERY_PARAM = 'tabName';

export const REPORTS_REQUEST_OPTIONS = { silent: true };

export const INTERACTIVE_ROW_CLICK_SELECTOR = [
  'a',
  'button',
  'input',
  'textarea',
  'select',
  'label',
  '[role="button"]',
  '.ant-btn',
  '.ant-checkbox-wrapper',
  '.ant-radio-wrapper',
  '.ant-select',
  '.ant-dropdown-trigger',
].join(',');

export const SORT_ORDER_OPTIONS = [
  { value: ReportsSortOrder.ASC, viewValue: 'Ascending' },
  { value: ReportsSortOrder.DESC, viewValue: 'Descending' },
];

export const EMPTY_VALUE = '--';

export const FULL_FILTER_CAPTION = 'Full filtered dataset';

export const OVERDUE_BUCKET_COLORS = [
  '#40a9ff',
  '#f2c94c',
  '#f2994a',
  '#f64d4f',
];

export const AGENT_CHART_COLORS = [
  '#40a9ff',
  '#03ffd2',
  '#f2c94c',
  '#f2994a',
  '#f64d4f',
  '#1890ff',
];
